
<div class="modal-dialog confirm-dialog" style="min-width: 850px; min-height: 400px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Add New Purchase Order</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="col">
          <div class="form-group form-check d-inline-block">
            <input class="form-check-input" type="radio" (change)="updatePurchaseOrders('customerPO')" id="customerPORadio" [(ngModel)]="purchaseOrdersCategory" name="radioSelectPurchaseOrderType" [value]="'customerPO'">
            <label class="form-check-label m-0">Customer PO</label>
          </div>
          <div class="form-group form-check m-0 d-inline-block ml-3">
            <input class="form-check-input" type="radio" (change)="updatePurchaseOrders('pendingPO')" id="pendingPORadio" [(ngModel)]="purchaseOrdersCategory" name="radioSelectPurchaseOrderType" [value]="'pendingPO'">
            <label class="form-check-label m-0">Pending PO</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-6">
          <label class="required" for="purchaseOrderNumber">Customer PO Number</label>
          <input class="form-control" id="purchaseOrderNumber" [(ngModel)]="purchaseOrderNumber" name="purchaseOrderNumber" placeholder="Enter PO Number" [disabled]="purchaseOrdersCategory === &quot;pendingPO&quot;">
        </div>
        <div class="form-group col-6">
          <label class="required" for="purchaseOrderDescription">Customer PO Description</label>
          <input class="form-control" id="purchaseOrderDescription" [(ngModel)]="purchaseOrderDescription" name="purchaseOrderDescription" placeholder="Enter PO Description">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary pl-5 pr-5" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-outline-primary pl-5 pr-5" type="button" (click)="create()" [ngClass]="{ 'btn-outline-secondary': !(purchaseOrderDescription !== '' &amp;&amp; purchaseOrderNumber !== '') }" [disabled]="!(purchaseOrderDescription !== '' &amp;&amp; purchaseOrderNumber !== '')">Create</button>
    </div>
  </div>
</div>